import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import favicon from "./favicon.svg";

// Add favicon dynamically
const link = document.createElement("link");
link.rel = "icon";
link.type = "image/svg+xml";
link.href = favicon;
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
